export default __webpack_public_path__ + "static/media/dropdown_icon.847e561f.svg";